import names from '../actions/actionNames';
import initialState from '../initialState';

const profileReducers = (state = initialState.profile, action) => {
  const { payload } = action;

  switch (action.type) {
    case names.LOAD_PROFILE_SUCCESS:
      return {
        ...state,
        user: payload.profile,
        isLoaded: true
      };
    case names.UPDATE_PROFILE_SUCCESS: {
      return {
        ...state,
        user: {
          ...state.user,
          ...payload.profile
        },
        isLoaded: true
      };
    }
    case names.LOAD_PROFILE_DETAILS_SUCCESS:
      return {
        ...state,
        user: payload.profile,
        isLoaded: true
      };
    case names.UPDATE_PROFILE_ERROR: {
      return {
        ...state,
        user: null,
        isLoaded: true,
        error: payload.error
      };
    }
    case names.LOGOUT_SUCCESS: {
      return {
        ...state,
        user: null,
        isLoaded: false,
        error: null
      };
    }
    case names.LOAD_USER_PROFILE_META_DATA_SUCCESS:
      return {
        ...state,
        languageData: action.payload.languageData
      };
    default:
      return state;
  }
};

export default profileReducers;
